
export interface DependantDetails {
    dateOfBirth: string;
    gender: string;
    relationship: string;
    dependantQuestion: string;
    riskAndStaticQuestion: any[];
}
